<template>
  <div>
    <h3>Spec</h3>
    <div class="h4 py-5">
      Spec會顯示於產品頁、產品比較 ; 同SubCategory的產品將同步Spec欄位。
    </div>

    <!-- items -->
    <div
      class="form-item-last-no-border d-flex pa-5"
      v-for="(item, i) in specs"
      :key="i"
    >
      {{ item.title }}
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState('subcategory', [
      'subcategory',
    ]),
    ...mapGetters('subcategory', [
      'specs',
    ]),
  },
};
</script>

<style></style>
